import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

// SERVICES
import { EnvironmentUtilService } from '../util/environment-util.service';

import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class BomApiService {
  environment = this.environmentUtilService.getEnvironment();

  constructor(
    private apiService :ApiService,
    private environmentUtilService :EnvironmentUtilService,
  ) {}

  delete(id :number) :Observable<any> {
    return this.apiService.delete(`${this.environment.urlV2}/bom/${id}`);
  }

  update(
    id :number,
    data :{ [param :string] :string | string[] },
  ) :Observable<any> {
    return this.apiService.put(`${this.environment.urlV2}/bom/${id}`, data);
  }

  create(data :{ [param :string] :string | string[] }) :Observable<any> {
    return this.apiService.post({
      path: `${this.environment.urlV2}/bom`,
      body: data,
    });
  }

  get(params ?:{ [param :string] :string | string[] }) :Observable<any> {
    return this.apiService.get(`${this.environment.urlV2}/bom`, { params });
  }

  getById(
    id :number,
    params ?:{ [param :string] :string | string[] },
  ) :Observable<any> {
    return this.apiService.get(`${this.environment.urlV2}/bom/${id}`, {
      params,
    });
  }
}
